"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ModelMapper = void 0;
class ModelMapper {
    toModel(modelResource) {
        return {
            id: modelResource.id,
            createdAt: new Date(modelResource.attributes.createdAt),
            name: modelResource.attributes.name,
            description: modelResource.attributes.description,
            inputKind: modelResource.attributes.inputKind,
            outputKind: modelResource.attributes.outputKind,
        };
    }
    toModelResource(model) {
        return {
            id: model.id,
            type: 'Model',
            attributes: {
                createdAt: model.createdAt.toISOString(),
                name: model.name,
                description: model.description,
                inputKind: model.inputKind,
                outputKind: model.outputKind,
            },
        };
    }
}
exports.ModelMapper = ModelMapper;
//# sourceMappingURL=#model-mapper.js.map